/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmPolicyRematchJobResultDto
 */
export interface MdmPolicyRematchJobResultDto {
    /**
     * 
     * @type {string}
     * @memberof MdmPolicyRematchJobResultDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPolicyRematchJobResultDto
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPolicyRematchJobResultDto
     */
    policyConfigurationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmPolicyRematchJobResultDto
     */
    dryRun?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    sourceRecordCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    batchCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    batchesProcessed?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    candidatesFound?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    autoMerged?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    pendingReview?: number;
    /**
     * 
     * @type {number}
     * @memberof MdmPolicyRematchJobResultDto
     */
    comparisonsPerformed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmPolicyRematchJobResultDto
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MdmPolicyRematchJobResultDto
     */
    message?: string;
}

/**
 * Check if a given object implements the MdmPolicyRematchJobResultDto interface.
 */
export function instanceOfMdmPolicyRematchJobResultDto(value: object): value is MdmPolicyRematchJobResultDto {
    return true;
}

export function MdmPolicyRematchJobResultDtoFromJSON(json: any): MdmPolicyRematchJobResultDto {
    return MdmPolicyRematchJobResultDtoFromJSONTyped(json, false);
}

export function MdmPolicyRematchJobResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmPolicyRematchJobResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'policyConfigurationId': json['policyConfigurationId'] == null ? undefined : json['policyConfigurationId'],
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
        'sourceRecordCount': json['sourceRecordCount'] == null ? undefined : json['sourceRecordCount'],
        'batchCount': json['batchCount'] == null ? undefined : json['batchCount'],
        'batchesProcessed': json['batchesProcessed'] == null ? undefined : json['batchesProcessed'],
        'candidatesFound': json['candidatesFound'] == null ? undefined : json['candidatesFound'],
        'autoMerged': json['autoMerged'] == null ? undefined : json['autoMerged'],
        'pendingReview': json['pendingReview'] == null ? undefined : json['pendingReview'],
        'comparisonsPerformed': json['comparisonsPerformed'] == null ? undefined : json['comparisonsPerformed'],
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function MdmPolicyRematchJobResultDtoToJSON(json: any): MdmPolicyRematchJobResultDto {
    return MdmPolicyRematchJobResultDtoToJSONTyped(json, false);
}

export function MdmPolicyRematchJobResultDtoToJSONTyped(value?: MdmPolicyRematchJobResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetClass': value['assetClass'],
        'entityType': value['entityType'],
        'policyConfigurationId': value['policyConfigurationId'],
        'dryRun': value['dryRun'],
        'sourceRecordCount': value['sourceRecordCount'],
        'batchCount': value['batchCount'],
        'batchesProcessed': value['batchesProcessed'],
        'candidatesFound': value['candidatesFound'],
        'autoMerged': value['autoMerged'],
        'pendingReview': value['pendingReview'],
        'comparisonsPerformed': value['comparisonsPerformed'],
        'success': value['success'],
        'message': value['message'],
    };
}

